import type React from 'react';

function YoutubeIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 800 566.1"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <title>Youtube Icon</title>

      <g id="Layer_1" data-name="Layer 1">
        <path
          d="M633.85,0H166.15C74.39,0,0,74.39,0,166.15v233.8c0,91.76,74.39,166.15,166.15,166.15h467.7c91.76,0,166.15-74.39,166.15-166.15V166.15c0-91.76-74.39-166.15-166.15-166.15Zm-112.37,294.43l-218.76,104.33c-5.83,2.78-12.56-1.47-12.56-7.93V175.64c0-6.55,6.91-10.79,12.75-7.83l218.76,110.86c6.5,3.3,6.39,12.62-.19,15.76Z"
          fill="#f61c0d"
        />
      </g>
    </svg>
  );
}

export default YoutubeIcon;
